import { fetchWithTimeout, responseError, readJsonResponse } from './apiRequest';
import { withClientVersion } from './clientVersion';

export async function resolvePodcast(base, url, session, signal) {
  const response = await fetchWithTimeout(withClientVersion(`${base}/podcast/resolve`), {
    method: 'POST', signal,
    headers: { Authorization: `Bearer ${session.access_token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ url }),
  });
  const result = await readJsonResponse(response);
  if (!response.ok) throw responseError(response, result);
  if (!result || typeof result !== 'object' || Array.isArray(result)
      || (!result.episode && !Array.isArray(result.episodes))) {
    throw Object.assign(new Error('The server returned an invalid podcast response.'), {
      code: 'malformed_response', operation: 'podcast_resolve', termination_reason: 'parse',
    });
  }
  return result;
}
